<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between">
			<h2 class="mb-4">Email Template</h2>
			<v-spacer></v-spacer>
			<v-btn v-if="emailTemplateList.length == 0" color="primary" @click="initiateEmailTemplate()">Create Initiate Email Template</v-btn>
		</div>
		<v-card v-if="emailTemplateList.length > 0">
			<v-tabs v-model="tab" background-color="primary" dark grow show-arrows>
				<v-tab v-for="(item, index) in emailTemplateList" :key="index">{{ item.type.replace("Admin_", "").replaceAll("_", " ") }}</v-tab>
			</v-tabs>

			<v-tabs-items v-model="tab">
				<v-tab-item v-for="(emailTemplate, idxEmailTemplate) in emailTemplateList" :key="idxEmailTemplate">
					<v-card flat>
						<v-card-text>
							<v-text-field v-model="emailTemplate.subject" label="Subject" outlined dense></v-text-field>
							<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="$root.initTinyMceFromVueEditor(280)" v-model="emailTemplate.template"></editor>
							<div class="d-flex justify-end">
								<v-btn color="primary" class="mt-4" @click="emailPreview(emailTemplate, emailTemplate.type)" style="margin-right:5px">Preview</v-btn>
								<v-btn color="primary" class="mt-4" @click="inputRecipientEmail(emailTemplate)" style="margin-right:5px">Send Test Email</v-btn>
								<v-btn color="primary" class="mt-4" @click="save(emailTemplate)">Save</v-btn>
							</div>
							<strong>Available parameters</strong>
							<div v-for="(parameter, idxParameter) in parameters" :key="idxParameter">
								<v-row v-if="emailTemplate.type == 'Admin_Welcome_Email' && (parameter == '{userName}' || parameter == '{tenantName}' || parameter == '{resetPasswordUrl}' || parameter == '{email}')">
									<v-col cols="12" sm="2">
										<code>{{parameter}}</code>
									</v-col>
									<v-col></v-col>
								</v-row>
								<v-row v-if="emailTemplate.type == 'Admin_Reset_Password_General' && (parameter == '{email}' || parameter == '{resetPasswordUrl}')">
									<v-col cols="12" sm="2">
										<code>{{parameter}}</code>
									</v-col>
									<v-col></v-col>
								</v-row>
								<v-row v-if="emailTemplate.type == 'Admin_Password_Confirmation_Email' && (parameter == '{userName}' || parameter == '{tenantName}' || parameter == '{tenantUrl}' || parameter == '{email}')">
									<v-col cols="12" sm="2">
										<code>{{parameter}}</code>
									</v-col>
									<v-col></v-col>
								</v-row>
								<v-row v-if="emailTemplate.type == 'Admin_Slug_Confirmation' && (parameter == '{tenantName}' || parameter == '{oldSlug}' || parameter == '{newSlug}')">
									<v-col cols="12" sm="2">
										<code>{{parameter}}</code>
									</v-col>
									<v-col></v-col>
								</v-row>
							</div>
						</v-card-text>
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-card>

		<v-dialog
			v-if="showEmailPreview" 
			v-model="showEmailPreview"
			no-click-animation
			persistent
			transition="dialog-bottom-transition"
			content-class="col-sm-7 col-12 hide-box-shadow ma-0 pa-0"
			style="overflow: hidden"
			scrollable
			max-width="750px"
		>
			<v-card>
				<v-card-title class="headline">
					<v-spacer></v-spacer>
					<v-btn icon @click="showEmailPreview = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<h2>
						{{emailTemplateSubjectPreview}}
					</h2>
					<br />
					<div v-html="emailTemplatePreview"></div>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-if="showSendTestEmail" v-model="showSendTestEmail" max-width="350" scrollable>
			<v-card>
				<v-form ref="sendTestEmail" v-model="valid" @submit.prevent="sendTestEmail">
				<v-card-text>
					<v-text-field v-model="recipientEmail" label="Email" :rules="[(v) => !!v || 'Email is required']"></v-text-field>
					<div class="d-flex justify-end">
						<v-btn color="primary darken-1" text @click="showSendTestEmail=false">Close</v-btn>
						<v-btn :disabled="!valid" type="submit" color="primary darken-1" depressed tile>Send</v-btn>
					</div>
				</v-card-text>
				</v-form>
			</v-card>
		</v-dialog>
	</div>
</template>
        
<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	components: {
		editor: Editor
	},
	data() {
		return {
			entity: {},
			emailTemplateList: [],
			tab: null,
			showEmailPreview: false,
			showSendTestEmail: false,
			emailTemplatePreview: null,
			emailTemplateSubjectPreview: null,
			recipientEmail: null,
			emailTemplateTest: {},
			valid: true,
			parameters: ["{userName}","{tenantName}","{eventTime}","{resetPasswordUrl}","{tenantUrl}", "{email}" , "{oldSlug}", "{newSlug}"],
			customToolbar: [ 
							[{header: [false, 1, 2, 3, 4, 5, 6]}],
							["bold", "italic", "underline", "strike"],
							[{align: ""}, {align: "center"}, {align: "right"}, {align: "justify"}],
							["blockquote", "code-block"],
							[{ list: "bullet" }, { list: "ordered" }, { list: "check" }],
							[{color: []}, {background: []}],
							["link", "image", "video"], ["clean"]
							]
		};
	},
	mounted() {
		this.listEmailTemplate();
	},
	methods: {
		listEmailTemplate() {
			axios.get("/system/emailtemplate/admin/list").then(response => {
				this.emailTemplateList = response.data;
				for (var i = 0; i < this.emailTemplateList.length; i++) {
					if (this.emailTemplateList[i].template) {
						if (this.emailTemplateList[i].type == 'Admin_Reset_Password_General' ) {
							this.emailTemplateList[i].template = this.emailTemplateList[i].template.replace("{actionUrl}", "{resetPasswordUrl}")
						}
						if (this.emailTemplateList[i].type == 'Admin_Welcome_Email' ) {
							this.emailTemplateList[i].template = this.emailTemplateList[i].template.replace("{actionUrl}", "{tenantUrl}")
						}
						this.emailTemplateList[i].default = false;
					} else {
						this.emailTemplateList[i].default = true;
					}
				}
			});
		},
		initiateEmailTemplate() {
			axios.post("/system/emailtemplate/initiate").then(() => {
				this.listEmailTemplate();
			});
		},
		save(entity) {
			let formData = new FormData();
			formData.append("entity", JSON.stringify(entity));
			axios.post("/system/emailtemplate/admin/edit", formData).then(() => {
				this.listEmailTemplate();
			});
		},
		emailPreview(emailTemplate){
			axios
				.post("/system/emailtemplate/preview",{
					experienceId: this.experienceId,
					emailTemplate: emailTemplate.template,
					emailTemplateType: emailTemplate.type,
					emailSubject: emailTemplate.subject
				})
				.then((response) => {
					this.emailTemplateSubjectPreview = response.data.subject;
					this.emailTemplatePreview = response.data.template;
					this.showEmailPreview = true;
				})
				.catch(() => {});
		},
		sendTestEmail(){
			axios
				.post("/system/emailtemplate/send/testemail",{
					experienceId: this.experienceId,
					emailTemplate: this.emailTemplateTest.template,
					emailTemplateType: this.emailTemplateTest.type,
					emailSubject: this.emailTemplateTest.subject,
					recipientEmail: this.recipientEmail
				})
				.then(() => {
					this.showSendTestEmail = false;
					this.$refs.sendTestEmail.reset();
				})
				.catch(() => {});
		},
		inputRecipientEmail(emailTemplate){
			this.showSendTestEmail = true;
			this.emailTemplateTest = emailTemplate;
		}
	}
};
</script>